export default {
  todo: {
    itemType: {
      checklist: 'Checklist',
      note: 'Note',
    },
    checklistTemplateModal: {
      title: 'Select checklist title',
    },
    hideCompletedChecklists: 'Hide completed checklists',
  },
};
